import { render, staticRenderFns } from "./AvailablesCasas.vue?vue&type=template&id=a674cf18&scoped=true"
import script from "./AvailablesCasas.vue?vue&type=script&lang=js"
export * from "./AvailablesCasas.vue?vue&type=script&lang=js"
import style0 from "./AvailablesCasas.vue?vue&type=style&index=0&id=a674cf18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a674cf18",
  null
  
)

export default component.exports